import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import numeral from "numeral";
import EstimatePrice from "./EstimatePrice";

const style = {
  boxLabel: {
    display: "inline-block",
    marginTop: 26,
    marginLeft: 59
  },
  label: {
    height: 24,
    width: 100,
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 16
  },
  trUpdate: {
    display: "flex",
    marginBottom: 43
  },
  trTransfer: {
    display: "flex"
  },
  textPriceUpdate: {
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 13,
    marginLeft: 65,
    marginTop: 2
  },
  textPrice: {
    extend: "textPriceUpdate",
    fontSize: 16,
    fontWeight: 600,
    textAlign: "right",
    width: 110,
    marginLeft: 186
  },
  labelPrice: {
    color: "#A7A8A8",
    fontFamily: "Fira Sans",
    fontSize: 14,
    fontWeight: 400,
    display: "block"
  },
  boxValue: {
    height: 165,
    backgroundColor: "#FCFCFC"
  },
  boxResult: {
    extend: "box",
    height: 245,
    width: 766,
    borderTop: "3px solid #0E283D",
    border: "1px solid #F2F2F2",
    backgroundColor: "#FFFFFF",
    marginBottom: 10
  }
};

const RolloutsPrice = ({
  classes,
  deviceUpdate,
  rolloutPrice,
  transferPrice,
  rollout
}) => {
  const device = numeral(Math.ceil(deviceUpdate)).format("0,0");
  const priceRollout = numeral(rolloutPrice).format("$0,0.00");
  const transferTotal = numeral(transferPrice).format("$0,0.00");
  let rolloutPerDevice = rolloutPrice / deviceUpdate;
  rolloutPerDevice = deviceUpdate > 0 ? rolloutPerDevice : 0.0;
  rolloutPerDevice = numeral(rolloutPerDevice).format("$0,0.0000");
  let transferPerDevice = transferPrice / deviceUpdate;
  transferPerDevice = deviceUpdate > 0 ? transferPerDevice : 0.0;
  transferPerDevice = numeral(transferPerDevice).format("$0,0.00");
  const props = { rollout, rolloutPrice, transferPrice };

  return (
    <div className={classes.boxResult}>
      <div className={classes.boxValue}>
        <table className={classes.boxLabel}>
          <tbody>
            <tr className={classes.trUpdate}>
              <td className={classes.label}>Update fee</td>
              <td className={classes.textPrice}>
                {priceRollout}
                <span className={classes.labelPrice}>{device} devices</span>
              </td>
              <td className={classes.textPriceUpdate}>
                {rolloutPerDevice}
                <span className={classes.labelPrice}>per device</span>
              </td>
            </tr>
            <tr className={classes.trTransfer}>
              <td className={classes.label}>Transfer fee</td>
              <td className={classes.textPrice}>
                {transferTotal}
                <span className={classes.labelPrice}>{device} devices</span>
              </td>
              <td className={classes.textPriceUpdate}>
                {transferPerDevice}
                <span className={classes.labelPrice}>per device</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <EstimatePrice {...props} />
    </div>
  );
};

RolloutsPrice.propTypes = {
  classes: PropTypes.object.isRequired,
  rollout: PropTypes.number.isRequired,
  rolloutPrice: PropTypes.number.isRequired,
  transferPrice: PropTypes.number.isRequired,
  deviceUpdate: PropTypes.number.isRequired
};

export default injectSheet(style)(RolloutsPrice);
